import { render, staticRenderFns } from "./JobPrePublishedPreviewMessageForm.vue?vue&type=template&id=f23509e8"
import script from "./JobPrePublishedPreviewMessageForm.vue?vue&type=script&lang=js"
export * from "./JobPrePublishedPreviewMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports